import { render, staticRenderFns } from "./IdManagerRetireMergeIdDetails.vue?vue&type=template&id=253ea077&scoped=true&"
import script from "./IdManagerRetireMergeIdDetails.vue?vue&type=script&lang=js&"
export * from "./IdManagerRetireMergeIdDetails.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerRetireMergeIdDetails.vue?vue&type=style&index=0&id=253ea077&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ea077",
  null
  
)

export default component.exports